import { averageVMDto } from '../dto/averageVMDto';
import { tableViewModel } from '../views/tableViewModel';

export class averageVMTransformer {
  public static from(averageVM: averageVMDto): tableViewModel[] {
    return <tableViewModel[]>[
      {
        name: 'vCPUs',
        value: averageVM.vcpu == null ? '-' : averageVM.vcpu.toString()
      },
      {
        name: 'Active Memory',
        value:
          averageVM.activeMemory == null
            ? '-'
            : (averageVM.activeMemory).toFixed(2) + ' GiB'
      },
      {
        name: 'Provisioned Memory',
        value:
          averageVM.provisionedMemory == null
            ? '-'
            : (averageVM.provisionedMemory).toFixed(2) + ' GiB'
      },
      {
        name: 'Memory Oversubscription',
        value:
          averageVM.memoryOversubscription == null ? '-' : averageVM.memoryOversubscription + '%'
      },
      {
        name: 'Guest Used Disk',
        value:
          averageVM.guestUsedDisk == null
            ? '-'
            : (averageVM.guestUsedDisk).toFixed(2) + ' GiB'
      },
      {
        name: 'Guest Whitespace',
        value: averageVM.guestWhiteSpace == null ? '-' : averageVM.guestWhiteSpace + '%'
      },
      {
        name: 'Guest iSCSI Present',
        value:
          averageVM.isGuestiSCSIPresent == null
            ? '-'
            : DisplayGuestiSCSIPresent(averageVM.isGuestiSCSIPresent)
      }
    ];

    function DisplayGuestiSCSIPresent(isGuestiSCSIPresent: boolean) {
      return isGuestiSCSIPresent == true ? 'Yes' : 'No';
    }
  }
}
